<template>
  <div class="container">
    <div class="row">
      <div id="stepper1" class="bs-stepper w-100">
        <div class="bs-stepper-header">
          <div class="step" data-target="#test-l-1">
            <button class="step-trigger">
              <span class="bs-stepper-circle">1</span>
              <span class="bs-stepper-label">Comprobante</span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" data-target="#test-l-2">
            <button class="step-trigger">
              <span class="bs-stepper-circle">2</span>
              <span class="bs-stepper-label">Dirección</span>
            </button>
          </div>
        </div>
        <div class="bs-stepper-content">
          <form>
            <div id="test-l-1" class="content">
              <div class="alert alert-info border border-info rounded" role="alert">
                <ul>
                  <li>Pagos efectuados antes de las 9 a.m. de lunes a viernes serán entregados el mismo día.</li>
                  <li>
                    Pagos efectuados después de las 9 a.m o fines de semana, serán entregados el siguiente
                    día hábil.
                  </li>
                </ul>
              </div>
              <p class="h2 text-center font-weight-bold mb-0">
                {{ order.totalAmount | currency('Bs.', 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
                symbolOnLeft: true,
                spaceBetweenAmountAndSymbol: true
                })
                }}
              </p>
              <banks />
              <h5>Adjunta el comprobante de pago</h5>
              <div class="form-group">
                <label for="capture">Capture de transferencia</label>
                <input
                  type="file"
                  class="form-control-file"
                  :class="{'is-invalid': !validCapture.result}"
                  @change="handleCapture"
                  id="capture"
                />
                <div class="invalid-feedback">{{ validCapture.message }}</div>
              </div>
              <div class="form-group">
                <label for="bank">Banco</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': !validBank.result}"
                  v-model="formBank.bank"
                  placeholder="Banco donde fue realizada"
                  id="bank"
                />
                <div class="invalid-feedback">{{ validBank.message }}</div>
              </div>
              <div class="form-group">
                <label for="ref">Referencia</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': !validRef.result}"
                  v-model="formBank.ref"
                  placeholder="Nro. de referencia"
                  id="ref"
                />
                <div class="invalid-feedback">{{ validRef.message }}</div>
              </div>
              <div class="form-group">
                <label for="description">Detalles de la transferencia</label>
                <textarea
                  class="form-control"
                  :class="{'is-invalid': !validDescription.result}"
                  v-model="formBank.description"
                  id="description"
                  placeholder="Banco, nombre, documento de identidad, etc."
                  rows="3"
                />
                <div class="invalid-feedback">{{ validDescription.message }}</div>
              </div>
              <div class="form-group mt-3">
                <label for="invoiceCustomer">Factura a nombre de:</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': !validInvoiceCustomer.result}"
                  v-model="formBank.invoiceCustomer"
                  placeholder="Nombre o razón social"
                  id="invoiceCustomer"
                />
                <div class="invalid-feedback">{{ validInvoiceCustomer.message }}</div>
              </div>
              <div class="text-right">
                <button
                  @click="stepper.next()"
                  :disabled="disabledBank"
                  class="btn btn-primary"
                  type="button"
                >Siguiente</button>
              </div>
              <br />
            </div>
            <div id="test-l-2" class="content">
              <template v-if="order.deliveryPriority">
                <div class="text-center mb-2">
                  <button
                    @click="selectedDelivery = !selectedDelivery"
                    class="btn btn-info"
                    type="button"
                  >Quiero {{buttonLabel}}</button>
                </div>
              </template>
              <template v-if="selectedDelivery">
                <div class="alert alert-success border border-success rounded" role="alert">
                  <p class="mb-1 h5">¡Enhorabuena! tu pedido será a domicilio</p>
                  <hr />
                  <p class="mb-0 font-italic small">Válido sólo para Barquisimeto y Cabudare</p>
                </div>
                <h5>Selecciona una dirección de envío</h5>
                <div class="form-check" v-for="(address, index) in addresses" :key="index">
                  <input
                    class="form-check-input"
                    type="radio"
                    v-model="selectedAddress"
                    :id="address.id"
                    :value="address.description"
                  />
                  <label class="form-check-label" :for="address.id">{{ address.description }}</label>
                </div>
                <div class="form-check">
                  <input
                    v-model="selectedAddress"
                    class="form-check-input"
                    type="radio"
                    id="newDirection"
                    value="new"
                  />
                  <label class="form-check-label" for="newDirection">Nueva dirección</label>
                </div>
                <div class="form-group mt-1" v-if="newAddressFlag">
                  <label for="newAddress">Ingrese su nueva dirección</label>
                  <textarea
                    v-model="newAddress"
                    class="form-control"
                    :class="{'is-invalid': !validNewAddress.result}"
                    id="newAddress"
                    placeholder="Estado, ciudad, parroquia, sector, carrera, calles, nro. casa, etc."
                    rows="3"
                  />
                  <div class="invalid-feedback">{{ validNewAddress.message }}</div>
                </div>
              </template>
              <template v-else>
                <h5>Selecciona una ubicación donde retirar tu pedido:</h5>
                <div class="form-check" v-for="(pharmacy, index) in pharmacies" :key="index">
                  <input
                    class="form-check-input"
                    type="radio"
                    v-model="selectedAddress"
                    :id="pharmacy.id"
                    :value="`${pharmacy.description} (${pharmacy.name})`"
                  />
                  <label
                    class="form-check-label"
                    :for="pharmacy.id"
                  >{{ pharmacy.description }} ({{ pharmacy.name }})</label>
                </div>
              </template>
              <div class="form-group mt-3">
                <label for="recipientName">Destinatario</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': !validRecipientName.result}"
                  v-model="recipientName"
                  placeholder="Nombre del destinatario"
                  id="recipientName"
                />
                <div class="invalid-feedback">{{ validRecipientName.message }}</div>
              </div>
              <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-info" @click="stepper.previous()" type="button">Atrás</button>
                <button
                  class="btn btn-primary"
                  :disabled="disabledAddress"
                  @click="submitPay"
                  type="button"
                >Finalizar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bs-stepper/dist/css/bs-stepper.min.css";
const Banks = () => import("@/components/common/Banks");
import { isValidField, isDirtyField } from "@/utils/formValidation";
import {
  getOrderApi,
  getAddressesApi,
  getPharmaciesApi,
  payOrderApi
} from "@/api/modules";
import { mapActions, mapGetters } from "vuex";
import Stepper from "bs-stepper";
export default {
  props: ["id"],
  components: {
    Banks
  },
  data() {
    return {
      order: {},
      addresses: [],
      pharmacies: [],
      selectedAddress: "",
      formBank: {
        capture: "",
        ref: "",
        bank: "",
        description: "",
        invoiceCustomer: ""
      },
      newAddressFlag: false,
      newAddress: "",
      recipientName: "",
      selectedDelivery: false
    };
  },
  watch: {
    selectedAddress(value) {
      this.newAddressFlag = value === "new";
    },
    selectedDelivery() {
      this.selectedAddress = "";
      this.newAddress = "";
      this.newAddressFlag = false;
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    buttonLabel() {
      return this.selectedDelivery
        ? "retirar en farmacia"
        : "recibir a domicilio";
    },
    disabledBank() {
      return !(
        this.validCapture.result &&
        this.validBank.result &&
        this.validRef.result &&
        this.validInvoiceCustomer.result &&
        this.validDescription.result
      );
    },
    disabledAddress() {
      return (
        !isDirtyField(this.selectedAddress) ||
        !isDirtyField(this.recipientName) ||
        (this.newAddressFlag && !this.validNewAddress.result)
      );
    },
    validCapture() {
      return isValidField(this.formBank.capture, ["required"]);
    },
    validRef() {
      return isValidField(this.formBank.ref, ["required"]);
    },
    validBank() {
      return isValidField(this.formBank.bank, ["required"]);
    },
    validInvoiceCustomer() {
      return isValidField(this.formBank.invoiceCustomer, ["required"]);
    },
    validRecipientName() {
      return isValidField(this.recipientName, ["required"]);
    },
    validDescription() {
      return isValidField(this.formBank.description, ["required"]);
    },
    validNewAddress() {
      return isValidField(this.newAddress, ["required"]);
    }
  },
  mounted() {
    this.recipientName = this.currentUser.person.name;
    this.formBank.invoiceCustomer = this.currentUser.person.name;
    this.stepper = new Stepper(document.querySelector(".bs-stepper"), {
      linear: true,
      animation: true
    });
  },
  created() {
    this.getOrder();
  },
  methods: {
    ...mapActions(["addMessage"]),
    handleCapture(event) {
      this.formBank.capture = event.target.files[0];
    },
    async getOrder() {
      let serviceResponse = await getOrderApi(this.id);
      if (serviceResponse.status) {
        this.order = serviceResponse.data;
        this.selectedDelivery = this.order.deliveryPriority;
        this.loadFharmaciesOrAddresses();
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    },
    loadFharmaciesOrAddresses() {
      const { deliveryPriority } = this.order;
      if (deliveryPriority) this.getAddresses();
      this.getPharmacies();
    },
    async getAddresses() {
      let serviceResponse = await getAddressesApi(localStorage.ClientId);
      if (serviceResponse.status) {
        this.addresses = serviceResponse.data;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    },
    async getPharmacies() {
      let serviceResponse = await getPharmaciesApi();
      if (serviceResponse.status) {
        this.pharmacies = serviceResponse.data;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    },
    async submitPay() {
      const body = {
        ...this.formBank,
        address: this.newAddressFlag ? this.newAddress : this.selectedAddress,
        newAddressFlag: this.newAddressFlag,
        recipientName: this.recipientName
      };
      let formData = new FormData();
      formData.append("file", body.capture);
      delete body.capture;
      formData.append("body", JSON.stringify(body));

      let serviceResponse = await payOrderApi(this.id, formData);
      if (serviceResponse.status) {
        this.$router.push("/orders");
      }
      let message_obj = {
        message: serviceResponse.message.text,
        messageClass: serviceResponse.status ? "success" : "danger",
        autoClose: true
      };
      this.addMessage(message_obj);
    }
  }
};
</script>

<style>
</style>